import React, { useState, useEffect, useContext } from "react";
import { useAnalysisStocks } from "../../hooks/useAnalysisStocks";
import { StateContext } from "../../store/context";
import { TitleArea } from "../../components/Typography/titleArea";
import { LoadingData, NoDataDetails } from "./components/noDetails";
import { StockSelectOptions } from "./components/stockSelectOptions";
import { usePreventCopy } from "../../hooks/usePreventCopy";
import StockAnalysisTabs from "./components/StockAnalysisTabs";
import DisclaimerButton from "../../components/DisclaimerButton";
import "../../styles/theme-tokens.css";
import "../../styles/glass-tokens.css";
import "./singleStockAnalysis.theme.css";

const SingleStockAnalysisScreen: React.FC = (): React.ReactElement => {
  usePreventCopy();
  const {
    baseCurrency,
    authUser: { allowed, sub_plan, role_name },
  } = useContext(StateContext);

  const [adverts, setAds] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [profileData, setProfileData] = useState<any>(null);
  const [activeTab, setActiveTab] = useState<string>("company_profile");
  const [selectedStock, setSelectedStock] = useState<any>(null);
  const [sectorPeers, setSectorPeers] = useState<any[]>([]);

  const {
    response,
    loading: stockLoading,
  } = useAnalysisStocks(selectedStock?.id, selectedStock?.ai_reviewed_summary);

  useEffect(() => {
    if (!selectedStock?.id || !response) return;
    const refreshedStock = response
      .flatMap((section: any) => section.options ?? [])
      .find((stock: any) => Number(stock.id) === Number(selectedStock.id));

    if (refreshedStock?.ai_reviewed_summary) {
      setSelectedStock(refreshedStock);
    }
  }, [response, selectedStock?.id]);

  useEffect(() => {
    if (!selectedStock || !response) return;

    const allStocks = response.flatMap((section: any) => section.options ?? []);

    const peers = allStocks.filter(
      (s: any) =>
        s.sector_id === selectedStock.sector_id &&
        s.stock_market_id === selectedStock.stock_market_id,
    );

    setSectorPeers(peers);
  }, [selectedStock, response]);

  console.log("sectorPeers: ---> ", sectorPeers);

  const isPremiumUser =
    sub_plan === "Premium Plan" && role_name === "Premium Customer";

  const isBasicCustomer =
    sub_plan === "Free Plan" && role_name === "Basic Customer";

  return (
    <div className="vi-ssa flex md:flex-row flex-col items-center md:items-start w-full select-none">
      <div className="flex flex-col w-full md:w-full h-full items-start px-4 py-3 pb-10">
        <div className="w-full flex items-start justify-between gap-4">
          <TitleArea
            variant="page"
            title="Detailed Analysis"
            subTitle="Your complete financial snapshot — simplified, structured, and insightful."
          />
          <DisclaimerButton />
        </div>
        <hr className="hr-line w-full my-2" />

        <div className="w-full md:w-[500px]">
          <StockSelectOptions
            response={response}
            loading={stockLoading}
            selectedStock={selectedStock}
            setSelectedStock={setSelectedStock}
          />
        </div>

        <div className="w-full">
          <hr className="hr-line w-full my-2" />

          {loading ? (
            <LoadingData />
          ) : !loading ? (
            selectedStock ? (
              <StockAnalysisTabs
                stockLoading={stockLoading}
                activeTab={activeTab}
                onTabChange={setActiveTab}
                isPremiumUser={isPremiumUser}
                selectedStock={selectedStock}
                sectorPeers={sectorPeers}
                baseCurrency={baseCurrency}
              />
            ) : (
              <NoDataDetails />
            )
          ) : (
            <div className="chat-container" />
          )}
        </div>
      </div>
    </div>
  );
};

export default SingleStockAnalysisScreen;
